/* Page not found. Design: ConsoleErrors.dc.html, "Page not found" — says why
   and offers a way on: back to Overview, or search. */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePage, useShell } from '../Shell';
import { IcSearch, useGo } from '../kit';

const NotFound: React.FC = () => {
  const { openPalette } = useShell();
  const go = useGo();
  const loc = useLocation();
  usePage({
    key: 'other', title: 'Page not found', zanaContext: 'Page not found',
    zanaIntro: 'This address is not a console page. Tell me what you were looking for and I will find it.',
    prompts: ['Which buses need a look today?', 'Where are my buses right now?'],
  });

  return (
    <div className="up" style={{ display: 'flex', minHeight: '100%' }}>
      <div style={{ margin: 'auto', maxWidth: '400px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', padding: '24px' }}>
        <span className="eic" style={{ width: '56px', height: '56px', borderRadius: '14px', background: 'var(--s2)', color: 'var(--muted)' }}>
          <IcSearch size={26} />
        </span>
        <h1 className="h2" style={{ fontSize: '24px', lineHeight: '30px' }}>This page isn’t in the console</h1>
        <p className="sub" style={{ fontSize: '15px' }}>
          There is nothing at <span className="mono" style={{ fontSize: 14, wordBreak: 'break-all' }}>{loc.pathname}</span>. The link may be old or mistyped. Your buses, trips and records are all still here.
        </p>
        <div className="row" style={{ gap: '8px', marginTop: '4px' }}>
          <a className="btn b-ink" {...go('ConsoleOverview')}>Go to Overview</a>
          <button type="button" className="btn b-line" onClick={openPalette}>Search</button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
